import { DocumentVersionApproverStatus, type DocumentVersion } from "@models";

export const shouldShowTiptapApprovalPing = ({
  isRoutingVersion,
  selectedDocVersion,
  userId,
}: {
  isRoutingVersion: boolean;
  selectedDocVersion?: DocumentVersion | null;
  userId?: string;
}) => {
  if (!isRoutingVersion || !selectedDocVersion || !userId) {
    return false;
  }

  const currentUserApprover = selectedDocVersion.documentVersionApprover.find(
    (approver) => approver.userId === userId || approver.user.id === userId
  );

  return (
    currentUserApprover !== undefined &&
    currentUserApprover.approvalStatus !==
      DocumentVersionApproverStatus.APPROVED
  );
};
